import React from "react";
import { Table } from "kepler";
import ReactHtmlParser from "react-html-parser";

class DashboardPDTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingDonationsData: this.props.pendingDonationsData ? this.props.pendingDonationsData : [],
      pageNo: this.props.pageNo,
      rowInx: ""
    };
  }
  componentWillReceiveProps(nextProps) {
    let oldData = this.state.pendingDonationsData, // Array of data
      newData = nextProps.pendingDonationsData,
      pageNo = nextProps.pageNo;
    if (parseInt(pageNo) > 1) {
      let combinedData = oldData.concat(newData);
      this.setState({
        pendingDonationsData: combinedData
      });
    } else if (nextProps.pendingDonationsData) {
      this.setState({
        pendingDonationsData: nextProps.pendingDonationsData
      });
    }
  }
    componentDidMount() {
        $("table.pendingDonations").on("click", "tr.hasActivityData", function () {
            let toggle = $(this).next(".pdDetails").is(":visible");
            if (!toggle) {
                $(this).parent().addClass('selectedTBody');
            } else {
                $(this).parent().removeClass('selectedTBody');
            }
            $(this).next(".pdDetails").toggle();
            $(".icon", this).toggleClass("icon-arrow-up-small");
        });
    }

  render() {
    let dashboardPageMsg = this.props.dashboardPageMsg;
    let appendPendingDonationsData = this.state.pendingDonationsData || [];

    let renderPDTable = appendPendingDonationsData.map((result, index) => {
      let showIconClass = "", amountSign, hasActivityData = "";
      if (result.item_id) {
        showIconClass = "icon icon-arrow-down-small";
        hasActivityData = "hasActivityData";
      }
      amountSign = result.type === "U" ? (
          <span className="pos">+</span>
        ) : (
          <span className="neg">-</span>
        );
      return (
        <tbody key={index}>
          <tr className={`activity ${hasActivityData}`}>
            <td className="date">
              <span className="month">{result.month}</span>
              <span className="day">{result.date}</span>
              <span className="year">{result.year}</span>
            </td>
            <td className="transactionDescription">
              {result.donor_name}
              <i className={showIconClass} />
              <span>{result.donor_email_address}</span>
            </td>
            <td className="transactionDescription">{result.partner_name}</td>
            <td className="transactionDescription">
              {result.product_description}
            </td>
            <td className="amount">
              {amountSign}&nbsp;{result.amount}
            </td>
          </tr>
          <tr className="pdDetails">
            <td />
            <td colSpan="4" className="detailsWrap">
              {dashboardPageMsg.dashboard.ebayli} {result.item_id}
            </td>
          </tr>
        </tbody>
      );
    });

    return (
      <div>
        <Table className="activityTable pendingDonations hide">
          <thead>
            <tr>
              <th>{dashboardPageMsg.dashboard.date}</th>
              <th>{ReactHtmlParser(dashboardPageMsg.dashboard.donorName)}</th>
              <th>{dashboardPageMsg.dashboard.partner}</th>
              <th>{dashboardPageMsg.dashboard.program}</th>
              <th>{dashboardPageMsg.dashboard.amount}</th>
            </tr>
          </thead>
          {renderPDTable}
        </Table>
      </div>
    );
  }
}
export default DashboardPDTable;



// WEBPACK FOOTER //
// ./ppgf/components/dashboardPD.js